import { render } from "./homeManagerCenter.vue?vue&type=template&id=6c40d757&scoped=true"
import script from "./homeManagerCenter.vue?vue&type=script&lang=js"
export * from "./homeManagerCenter.vue?vue&type=script&lang=js"

import "./homeManagerCenter.vue?vue&type=style&index=0&id=6c40d757&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c40d757"]])

export default __exports__